// Copyright (c) 2017 Deere & Company

import { getDateFormat } from './get-date-format';
import { getStore } from '../../../../configmodules/store-reducer-config/store';
import moment from 'moment';

export const buildDate = (timestamp) => {

    if (!timestamp) {

        return '';

    }

    const userDateSetting = 'M/D/YYYY';

    return moment.utc(timestamp).format(userDateSetting);

};

export const getCorrectDateValue = (date) => date ?
    date.startOf('day').valueOf() :
    null;

export const transformDateValue = (date) => date ?
    moment.utc(date) :
    null;

export const isValidDate = (date, dateFormatKey) => {

    const dateFormat = dateFormatKey ?
        getDateFormat(dateFormatKey) :
        getDateFormat(getStore().getState().user.details.settings.general.dateFormat.key);

    return moment(date, dateFormat, true).isValid();

};
